export const MAINTENANCE_MODE = 'maintenance_mode';
export const MI_BANNER = 'major_incident_banner';
export const RETENTION_BANNER_WARNING = 'renewal_issues_warning_banner';
export const ONE_CLICK_PAYMENT_REDUCTION = 'show_direct_debit_reduction';
export const SHOW_RECOMMENDED_DIRECT_DEBIT = 'show_recommended_direct_debit';
export const ALLOW_ANYTIME_SIGNUP = 'allow_anytime_signup';
export const TARIFFS_FILTERING = 'tariffs_filtering';
export const SHOW_GREENER_ELECTRICITY = 'show_greener_electricity';
// Shared with the app: pick the bolt-on version that is effective now while
// P&T list the current and the future version together.
export const ENABLE_EFFECTIVE_BOLTON_VERSION =
  'enable_effective_bolton_version';
export const BILLING_HISTORY_CALLOUT = 'billing_history_callout';
export const EXPAND_FIRST_BILLING_PERIOD = 'expand_first_billing_period';
export const MOVE_OUT_CTA = 'move_out_cta';
export const HOMEPLAN_OFFER = 'home_plan_offer';
export const HOMEPLAN_NAV_LINK = 'homeplan_nav_link';
export const HOMERECOVER_NAV_LINK = 'homerecover_nav_link';
export const HOME_RECOVER_OFFER = 'homerecover_offer';
export const HOME_SERVICES_BLOCK_EXISTING_CUSTOMERS =
  'homeservices_block_existing_customers';
export const SHOW_ABS_IN_MORE_OFFERS = 'show_abs_in_more_offers';
export const OHS_2026_OFFER_CARDS = 'ohs_2026_addon_cards';
export const OMR_WITHOUT_MSN = 'omr_without_msn';
export const METER_SUMMARY = 'meter_summary';
export const ENABLE_MHHS_READ_FREQUENCY_SETTINGS =
  'enable_mhhs_read_frequency_settings';
export const SHOW_RENEWALS = 'show_orion_renewal';
export const KALUZA_METER_PHOTO = 'kaluza_meter_photo';
export const BALANCE_COMPONENT_CHANGES = 'balance_component_changes';
export const BILLING_COMPREHENSION = 'billing_comprehension';
export const OSV_1_BILL_DOWNLOAD = 'osv1Download';
export const ENHANCED_TUWY_JOURNEY = 'enhanced_tuwy_journey';
export const REWARDS_TUWY_JOURNEY = 'rewards_tuwy_journey';
export const MOVING_HOME_MAKE_PAYMENT = 'moving_home_make_payment';
export const EOC1_REDIRECT = 'enable_eoc1_redirect';
export const BEYOND_WEB_PRESENCE = 'beyond_web_presence';

// Kapi Switch over flags
export const KAPI_BILLING_API = 'kapi_billing_api';
export const KAPI_PAYOUTS_API = 'kapi_payouts_api';
export const KAPI_PLANS_API = 'kapi_plans_api';
export const KAPI_USAGE_READS_API = 'kapi_usage_reads_api';
export const KAPI_METER_READS_API_ENABLED = 'kapi_meter_reads_experience';
export const DD_RECALC_MESSAGING_JUNE_2025 =
  'enable_dd_recalc_messaging_june_2025';

// DHE - Drive (Charge Anytime)
export const CHARGE_ANYTIME_PAYG_A_B_TEST_PPM_V_KWH =
  'charge_anytime_payg_a_b_test_ppm_v_kwh'; // Enables AB test for price per mile vs price per kWh
export const CHARGE_ANYTIME_ENABLE_MANAGE_PLAN =
  'charge_anytime_enable_manage_plan'; // Enables the SideNav Charge Anytime Option and Manage Plan page
export const CHARGE_ANYTIME_REINSTATE = 'charge_anytime_reinstate'; // Enables the reinstate functionality
export const CHARGER_MODEL_SELECTION = 'chargers_model_selection'; // Enables EV Charger Model selection
export const DRIVE_ANYTIME = 'drive_anytime'; // Enables the whole Charge Anytime Signup Journey
export const CHARGE_ANYTIME_KWIK_FIT_MAINTENANCE =
  'charge_anytime_kwik_fit_maintenance'; // Shows the "Kwik Fit Club is under maintenance" notification

// Beta website cross-link banner (invite eligible customers to the new beta site).
export const BETA_WEBSITE_BANNER = 'beta_website_banner';

// Automatic redirect to the new site. Separate from the banner flag.
export const NEW_WEB_REDIRECT = 'new_web_redirect';

// /smart-booking web fallback: on sends to new web, off to the booking site.
export const SMART_BOOKING_NEW_WEB_REDIRECT = 'smart_booking_new_web_redirect';
